export default __webpack_public_path__ + "static/media/a' feitheamh.488d52c1.mp3";